module.exports = __webpack_public_path__ + "static/media/LOGOEasyPayslipHorizontal.1dc98731.svg";